import React, { Component } from 'react';
import moment from 'moment';
import ReactSVG from 'react-svg'

import time from '../../../../script/utils/time';
import timerIcon from '../../../../assets/icons/timer.svg';
import './driver.css';

export default class Driver extends Component {

    render() {

        const driverAssignedOrders = (this.props.driver.currentRunOrders ? this.props.driver.currentRunOrders : 0)
        const driverClosedOrders = (this.props.driver.currentRunClosedOrders ? this.props.driver.currentRunClosedOrders : 0)
        const driverOrderProgress = (driverAssignedOrders > 0 ? (driverClosedOrders / driverAssignedOrders * 100): 0)

        return (
            <li className={ 'driver ' +
                    (this.props.highlightedDriver && this.props.highlightedDriver.id === this.props.driver.id ? 'highlight' : '')
                }
                data-id={ this.props.driver.id }
                onClick={ event => this.props.onClick(this.props.driver.id, event) }
                onMouseOver={ event => this.props.onHighlight(this.props.driver, event) }
            >
                <div className="driver-name driver-info-item size-m" title={this.props.driver.name}>{ this.props.driver.name }</div>
                { this.props.driver.status === 'returning' && this.props.driver._returningInfo &&
                    <div className="driver-eta driver-info-item size-s map-driver-eta">
                        <ReactSVG path={timerIcon}/>
                        <span>{ moment(Date.now() - this.props.driver._returningInfo.duration).toNow(true) }</span>
                    </div>
                }
                <div className="driver-timer driver-info-item size-s">{ time.renderTimer(this.props.driver.updatedAt) }</div>
                { driverAssignedOrders > 0 &&
                    <div className="driver-orders-wrapper driver-info-item size-s">
                        <div className="driver-orders">
                            { driverClosedOrders }/{ driverAssignedOrders }
                        </div>
                        <div className="driver-orders-progress" style={
                            { width: driverOrderProgress + '%' } }
                        ></div>
                    </div>
                }
            </li>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/Sidebar/drivers-list/driver/index.js